import { ProductAttribute } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

import { SHORTCUT_PRODUCT_ATTRIBUTE_FIELDS } from '@@partner:graphql/shortcuts'

export interface ProductAttributeInfoInput {
  id?: GQL_ID
  name: string
  slug: string
  is_system: boolean
  prefix: string
  postfix: string
  is_searchable: boolean
  xname: string
  is_filterable: boolean
  filter_name: string
  value_type: string
}

export interface SaveProductAttribute {
  productAttribute: ProductAttribute
}

export interface SaveProductAttributeVariables {
  productAttributeInfo: ProductAttributeInfoInput
}

export const GQL_MUTATION_SAVE_PRODUCT_ATTRIBUTE = gql`
  mutation saveProductAttribute ($productAttributeInfo: ProductAttributeInfo) {
    productAttribute: saveProductAttribute(productAttributeInfo: $productAttributeInfo) {
      ${SHORTCUT_PRODUCT_ATTRIBUTE_FIELDS}
    }
  }
`

export const useMutateSaveProductAttribute = () => useMutation<SaveProductAttribute, SaveProductAttributeVariables>(
  GQL_MUTATION_SAVE_PRODUCT_ATTRIBUTE
)